import { useEffect } from 'react';

import CancelIcon from 'assets/icons/base/cancel-icon.svg';
import { useAmount, useMainNavigate, usePaymentError, useTranslate, useYM } from 'hooks';
import { useLoadData } from 'hooks/useLoadData';

import { PaymentWrapper } from '../payment-wrapper';
import { Button } from '../ui';

const PaymentError = () => {
  const { paymentData } = useLoadData();
  const { formattedAmount, commission, formattedCommission } = useAmount();
  const { t } = useTranslate();
  const { goToReturnUrl } = useMainNavigate();
  const { trackOnClick } = useYM();
  const { getPaymentError } = usePaymentError();

  useEffect(() => {
    trackOnClick('openErrorForm');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <PaymentWrapper className="bg-white md:bg-base-gray-100 flex w-full md:max-w-[560px] md:w-auto items-center md:items-start flex-col">
      <div className="flex flex-col text-center flex-grow mx-auto md:mx-0 md:text-left gap-12 md:justify-center md:gap-9 h-full">
        <div>
          <div className="block md:hidden mx-auto mb-4">
            <img src={CancelIcon} className="mx-auto" alt="error" />
          </div>
          <div>
            <h3 className="text-xl leading-6 text-base-red-200 font-bold">
              {getPaymentError(paymentData?.error, '1xbet.no-response-from-bank')}
            </h3>
            <p className="text-xs leading-4 font-normal mt-4 md:mt-2">
              {t('lang.if_error_repeats_contact_store_2')}
            </p>
          </div>
        </div>

        <div className="my-12 md:my-0">
          <dl className="mb-4 last:mb-0">
            <dt className="text-base leading-140 md:text-[10px] font-semibold md:font-normal tracking-[1px] mb-2 opacity-60">
              {t('lang.order_number')}
            </dt>
            <dd className="text-[22px] md:text-base leading-140 font-bold">{paymentData?.ID}</dd>
          </dl>
          <dl className="mb-4 last:mb-0">
            <dt className="text-base md:text-[10px] font-semibold md:font-normal tracking-[1px] mb-2 opacity-60">
              {t('amount')}
            </dt>
            <dd className="text-[22px] md:text-base leading-140 font-bold">{formattedAmount}</dd>
          </dl>
          {Number(commission) > 0 && (
            <dl className="mb-4 last:mb-0">
              <dt className="text-base md:text-[10px] font-semibold md:font-normal leading-3 tracking-[1px] mb-2 opacity-60">
                {t('commission')}
              </dt>
              <dd className="text-[22px] md:text-base leading-140 font-bold">
                {formattedCommission}
              </dd>
            </dl>
          )}
        </div>
        {paymentData?.returnURL && (
          <Button
            className="md:max-w-[270px] mt-2"
            onClick={() => goToReturnUrl(paymentData?.returnURL)}
          >
            {t('back_to_store')}
          </Button>
        )}
      </div>
    </PaymentWrapper>
  );
};

export { PaymentError };
